import { render, staticRenderFns } from "./admin_users_roles.vue?vue&type=template&id=02dfeb3b&scoped=true&"
import script from "./admin_users_roles.vue?vue&type=script&lang=js&"
export * from "./admin_users_roles.vue?vue&type=script&lang=js&"
import style0 from "./admin_users_roles.vue?vue&type=style&index=0&id=02dfeb3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dfeb3b",
  null
  
)

export default component.exports